module.exports = __webpack_public_path__ + "img/favicon.43c44274.png";